import { isUndefined, omit } from 'lodash';

import { Querystring } from 'utils/url';
import type { LocationWindow, RouterLocation } from 'types';

export function getLocationUrl(location: RouterLocation): string {
  if (location.querystring.length === 0) {
    return location.pathname;
  }

  return `${location.pathname}?${location.querystring}`;
}

export function getLocationWithExtendedQuery(location: RouterLocation | LocationWindow, query: {} = {}): RouterLocation {
  const currentQuery = location.query || {};

  const newQuery = {
    ...currentQuery,
    ...omit(query, Object.keys(query).filter(key => isUndefined(query[key])))
  };

  // $FlowIgnore - Cannot return object literal because undefined[1] is incompatible with string[2]
  return {
    ...location,
    querystring: Querystring.objectToString(newQuery),
    query: newQuery
  };
}

export function getLocationWithoutQueryElements(location: RouterLocation | LocationWindow, query: Array<string> = []): RouterLocation {
  const currentQuery = location.query || {};
  const newQuery = omit(currentQuery, query);

  // $FlowIgnore - Cannot return object literal because undefined[1] is incompatible with string[2]
  return {
    ...location,
    querystring: Querystring.objectToString(newQuery),
    query: newQuery
  };
}
